<template>
<!-- 新的测评答题页 -->
    <div class="sheet2-con">
        <div  class="head">
            <h2 v-for="(item,index) in intro" :key="index">{{item}}</h2>
        </div>
        <!-- 分块答题 -->
        <div class="answer-module" v-for="(item,index) in array" :key="index">
            <div class="module-child" @click="anQuestions(item.question,item.title,index,item.intro)">
                <!-- top -->
                <div class="title">
                    <div class="text text-ellipsis">{{item.title}}</div>
                    <img class="succ" v-if="isSuccess(index)"  src="@a/cp-succ.png" alt="">
                    <span v-else-if="isBeginQuest(index)">{{isBeginQuest(index)+'%'}}</span>
                    <img v-else  src="@a/cp-right.png" alt="">
                </div>
                <!-- 进度 -->
                <div v-if="isBeginQuest(index) && !isSuccess(index)" class="progress">
                    <van-progress
                        :percentage="isBeginQuest(index)"
                        :show-pivot="false"
                        color="#EB5032"
                        style="height:5px;border-radius:5px;"
                    />
                </div>
            </div>
        </div>
        <!-- 生成报告 -->
        <a class="submitBtn" v-if="isReport()" @click="saveReport()">生成报告</a>
        <!--  -->
        <p :class="['small',isReport()?'on':'']">新精英生涯（北京）教育科技有限公司提供内容与技术支持</p>
        <!-- 弹出协议说明 -->
        <van-popup class="agreement-box" v-model="agreementShow" :close-on-click-overlay="false">
            <div class="agreement-box-content">
                <h2 class="on">温馨提示</h2>
                <h4>欢迎使用本测评。如果您购买了测评用于您的个人发展，则只有当您同意他人或机构查看或使用你的结果时，他人或机构才有使用的权利。如果您的机构，学校或其他个人（以下简称“第三方”）为您购买了此评估，则我们会将您的结果同步给第三方，以促进您的发展和教育。</h4>
                <button class="btn on" @click="cfmHandle" >同意</button>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { setStorage,getStorage,deepCopy } from '@/utils/tools'
import { getData,saveData} from '@/api/measurement'
export default {
    data(){
        return{
            questObj:{},
            agreementShow:false
        }
    },
    computed:{
        // 是否开始答题
        isBeginQuest(){
            return function(index){
                return this.questObj[index+'percent'];
            }
            
        },
        // 是否已经答完本模块
        isSuccess(){
            return function(index){
                return this.questObj['idx'+index];
            }
            
        },
    },
    methods:{
        // 确认协议
        cfmHandle(){
            this.agreementShow=false;
            if(this.$route.path=='/ceping103'){
                this.questObj['agreementShow'] = this.agreementShow;
                // 请求进度接口
                saveData({
                    cid:this.cid,
                    data:String(this.questObj)!='{}'&&this.questObj?JSON.stringify(this.questObj):''
                }).then((data)=>{

                });
            }
            
        },
        isOk(bool){
            // 如果有未答完的题目 begin
            let numObj = {};
            let num = 0;
            for(let i =0;i<this.array.length;i++){
                for(let j =0;j<this.array[i].question.length;j++){
                    if(!this.questObj[parseInt(`103${this.array[i].question[j].id}`)]){
                        this.$set(this.questObj,`idx${i}`,false);
                        if(!bool){
                            this.$toast('还有题目未完成哦！(￣▽￣)');
                        }
                        
                        numObj[i]=numObj[i]>=1?numObj[i]+1:1;
                    }
                }
                if(numObj[i]>0){
                    num++;
                    this.$set(this.questObj,`${i}percent`,(((this.array[i].question.length-numObj[i])/this.array[i].question.length)*100).toFixed(2));
                }
            }
            // 如果有模块未完成不允许提交
            if(num>0){
                return
            }
            // 如果有未答完的题目 end
        },
        // 提交报告
        saveReport(){
            this.isOk();

            // 判断是否三个模块都完成
            let bool = this.questObj.idx0 && this.questObj.idx1 && this.questObj.idx2;
            let obj = deepCopy(this.questObj);
            // 拼接模块为一个数据格式
            let list = [];
            this.array.forEach((item, index) => {
                this.$delete(obj,'idx'+index);
                this.$delete(obj,index+'percent');
                list = list.concat(item.question);
            });

            // 处理数据格式
            let arr = [];
            let str = [];
            list.forEach((item, index) => {
                if (item.options && item.options.length>0){
                    arr.push({
                        qid: item.id,
                        eid: item.eid,
                        cid: item.cid,
                        score: bool?obj[parseInt(`103${item.id}`)]:getStorage(this.path, `103${item.id}`)
                    });
                    if(!item.score){
                        str.push(item.id);
                    }
                }
            });
            this.$emit("saveReportHandle", arr);
        },
        // 是否生成报告
        isReport(){
            let bool = true;
            for(let i=0;i<this.array.length;i++){
                if(!this.isSuccess(i)){
                    bool  = false;
                    break;
                }
            }
            return bool
        },
        
        /*
         *@param: arr 被点击模块题目数组
         *@return: 
         *@Description: 点击答题模块触发
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-01-17 14:55:27
        */
        anQuestions(arr,title,index,intro){
            this.isOk(true);
            // if(this.isSuccess(index)){
            //     this.$toast('你已答完此模块！');
            //     return
            // }
            // 将值存在sessionstorage中
            setStorage('/an_questions4','anQuestArr',{
                array:arr,
                data_:this.data_,
                interruptShow:this.interruptShow,
                intro:intro?intro.split('\n'):[],
                path:this.path,
                title:title,
                index:index,
                questObj:this.questObj,
                cid:this.cid
            })
            this.$router.push({
                path:'/an_questions4',
                query:{
                    idx:index,
                    path:'ceping103'
                }
            });
            
        },
        /*
         *@param: 
         *@return: 
         *@Description: 初始化获取答题进度
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-01-17 14:55:27
        */
        pullData(){
            //调用加载中
            this.$emit('loadingHandle',true,"获取答题进度中...");
            getData({
                cid:this.cid
            }).then((data)=>{
                this.questObj = data.data?JSON.parse(data.data):{};
                this.agreementShow = String(this.questObj.agreementShow)=='false'?this.questObj.agreementShow:true;
                //关闭加载中
                this.$emit('loadingHandle',false);
            });
        }
    },
    created(){
        this.pullData();
    },
    /*
    *@param: list 数组对象，intro 测评答题说明文案，pattern 他评，ta_nickname 昵称
    */
    props: ['data_','cid','array','intro','pattern','path','interruptShow'],
}
</script>

<style lang="scss" scoped>
.sheet2-con{
    padding: 0 30px 98px;
    p.small{
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        font-size:16px;
        color:#999999;
        width: 80%;
        text-align: center;
    }
    p.small.on{
        bottom:118px;
    }
    .head{
        margin: 60px 0;
        h2{
            font-size: 32px;
            color: #333;
            text-align: justify;
        }
    }
    .answer-module{
        display: flex;
        flex-direction: column;
        .module-child{
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 30px;
            padding: 40px 30px;
            box-shadow:0px 1px 8px 2px rgba(235,80,50,0.14);
            overflow: hidden;
            border-radius:12px;
            .title{
                display: flex;
                align-items: center;
                width:100%;
                .text{
                    font-size: 32px;
                    color: #333;
                    font-weight: bold;
                    width: 450px;
                    letter-spacing: 1px;
                    margin-right: auto;
                }
                img.succ{
                    width:44px;
                    height:31px;
                }
                img{
                    width: 16px;
                    height: 27px;
                }
                span{
                    font-size:32px;
                    color:#EB5032;
                }
            }
        }
        .progress{
            width:100%;
            border-radius: 5px;
            flex: 1;
            overflow: hidden;
            margin-top:30px;
        }
    }
    .submitBtn{
        background-color: #EB5032;
        font-size:34px;
        color:#fff;
        text-align:center;
        position: fixed;
        bottom:0;
        left:50%;
        width:100%;
        line-height:98px;
        max-width:750px;
        transform: translateX(-50%);
    }
}
button{
    width: 348px;
    line-height: 64px;
    height: 64px;
    background-color: #CCCCCC;
    color: #ffffff;
    border: 0;
    border-radius: 32px;
    margin-top: 265px;
    font-size: 30px;
}
button.on{
    background-color: #EB5032;

}
.agreement-box{
    width:540px;
    padding:42px 45px 62px;
    border-radius:12px;
    text-align: center;
    h2{
        margin:0 auto 42px;
        font-size:36px;
        color:#333333;
        font-weight:bold;
        line-height:1;
    }
    h4{
        font-size:26px;
        color:#333333;
        line-height:42px;
        text-align:justify;
    }
    .btn{
        margin-top:65px;
    }
}
</style>
<style lang="scss">
    #app{
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: #fff;
    }
</style>